import { fetchStocktakingOrdersRoutine } from 'modules/stocktakingOrders/ducks/actions'

const defaultState = {
  list: [],
  pagination: null,
  isLoading: false
}

const stocktakingOrdersReducer = (state = defaultState, action) => {
  switch (action.type) {
    case fetchStocktakingOrdersRoutine.TRIGGER:
      return {
        ...state,
        isLoading: true
      }
    case fetchStocktakingOrdersRoutine.FAILURE:
      return {
        ...state,
        isLoading: false
      }
    case fetchStocktakingOrdersRoutine.SUCCESS:
      return {
        ...state,
        list: action.payload.data,
        pagination: {
          itemsCount: action.payload.meta.total,
          totalPages: action.payload.meta.lastPage,
          perPage: action.payload.meta.perPage,
          currentPage: action.payload.meta.currentPage
        },
        isLoading: false
      }
    default:
      return state
  }
}

export default stocktakingOrdersReducer
